import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import styles from '../../style.module.scss'
import Loader from '../Loader'
import SideBar from '../../components/SideBar'
import AppBar from '../../components/AppBar'
import { useSelector } from 'react-redux'
import { sidebarStateSelector } from '../../store/auth/selectors'
import { LOGIN } from '../../routesConstants'

export function PrivateRoute({ component: Component, user, title, allowedRoles = [], ...rest }) {
  const sidebarState = useSelector(sidebarStateSelector())

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Redirect to="/" />
  }

  return (
    <div className={styles.appDiv}>
      <Loader />
      {user && (
        <div
          style={{ width: sidebarState === 'hidden' ? '96px' : '260px' }}
          className={styles.sideBarDiv}
        >
          <SideBar user={user} />
        </div>
      )}
      <div className={styles.container}>
        {user && (
          <div className={styles.appBarDiv}>
            <AppBar title={title} />
          </div>
        )}
        <div className={styles.contentDiv}>
          <Route
            {...rest}
            render={(props) => (user ? <Component {...props} /> : <Redirect to={LOGIN} />)}
          />
        </div>
      </div>
    </div>
  )
}

export default PrivateRoute
